import { useEffect, useState } from 'react'
import { FetchAdapter } from '../FetchAdapter/FetchAdapter'

export function useFetch(url, config) {
  const [data, setData] = useState({})
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() =>{
    const fetchData = async () => {
      try {
        const response = await FetchAdapter.get(url, config)
        const parsedResponse = await response.json()
        setData(parsedResponse)
      } catch(err) {
        setError(true)
      } finally {
        setLoaded(true)
      }
    }

    fetchData()
  }, [])

  return { data, loaded, error }
}